import { createContext, useContext } from 'react'
import { VERTICALS, DEFAULT_VERTICAL, type Terms } from '../domain/verticals'

export const TermsContext = createContext<Terms>(VERTICALS[DEFAULT_VERTICAL].terms)
export const useTerms = (): Terms => useContext(TermsContext)
